import { useState, useEffect } from 'react';
import { string, number } from 'prop-types';
import styled from 'styled-components';
import Select from 'react-select';
import Button from '../../StoraEnsoComponents/Button';
import ConfirmationModal from '../../ConfirmationModal';
import NotificationToast from '../../NotificationToast';
import { getUploadedImages, reuploadPicture, reuploadDone } from '../../../services/uploadingService';
import logoSrc from '../../../logo.svg';
import UploadPreview from '../../UploadingPage/UploadPreview';
import FileUpload from '../../UploadingPage/FileUpload';
import { useField, useForm } from 'react-final-form';
import findIndex from 'lodash.findindex';
import EXIF from "exif-js";
import Loading from '../../Loading';


const LoadingWrapper = styled.div`
     margin: 60px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Wrapper = styled.div`
max-width: 1000px;
margin: 0 auto;
`;
const Separator = styled.div`
  margin-bottom: 16px;
`;

const ButtonWrapper = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 48px;
  padding-bottom: 16px;
  background: linear-gradient(0deg, rgba(248,248,249,1) 0%, rgba(248,248,249,1) 65%, rgba(248,248,249,0) 100%);
  z-index: 20;

  ${Button} {
    margin: 4px;
    width: 15%;
  }
  `

const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
`;

const Result = styled.div`
  padding: 16px 32px;
  margin: 0 auto;
  text-align: center;
  background-color: ${({theme, result}) => result === 'positive' ? theme.colors.positive_bg : theme.colors.negative_bg};
  margin-bottom: 2rem;

  @media screen and (min-width: 768px) {
    min-width: 600px;
  }
`;


function UploadRefresh({id}) {

const [files, setFiles] = useState([]);
const [uploadedImages, setUploadedImages]= useState(null);
const [uploadFiles, setUploadFiles] = useState([]);
const [reuploaded, setReuploaded] = useState(false);
const [loading, setLoading] = useState(true);

  useEffect(() => {
  getUploadedImages(id).then(data=>{
    setUploadedImages(data)
    console.log(loading)
    setLoading(false)
  }
  );
    //todo progably spinner
}, []);

const filterFiles = (dropFiles) => {

    return new Promise((resolve) => {
        let filtered = dropFiles.map(f => {
            return new Promise((rSucess, rError) => {
                EXIF.getData(f.file, function () {
                    var exifData = EXIF.pretty(this);
                    if (exifData) {
                        let image = uploadedImages.find(u => u.date === EXIF.getTag(this, "DateTimeOriginal"));
                        if (image === undefined) {
                            return rSucess(f);
                        }
                        rError()

                    }
                })
            })
        });
        Promise.allSettled(filtered)
            .then((d) => {
                console.log(d)
                const data = d.filter(image=>image.status==="fulfilled").map(i=>i.value)
                console.log(data);
                setUploadFiles([
                    ...files,
                    ...data.map(item => ({
                      ...item,
                      preview: item.file.type === 'video/mp4'? logoSrc : URL.createObjectURL(item.file)
                    }))
                  ])
            })
    })

}

const startUploadingDrone = (uploadingFiles) => {
    return new Promise((resolve) => {
      const _files = uploadingFiles.filter(file => ['idle', 'failed'].includes(file.uploadStatus.status));

      let results = _files.map((file, index) => {
        return new Promise((rSucess, rError) => {
          reuploadPicture(file.file, id, (event) => {
            setUploadFiles(data => {
              let tempArr = [...data];
              const idx = findIndex(data, el => el.id === file.id);
              tempArr[idx] = {...data[idx], uploadStatus: { status: 'running', loaded: event.loaded }};
              return tempArr;
            });
          })
          .then(() => {
            setUploadFiles(data => {
              let tempArr = [...data];
              const idx = findIndex(data, el => el.id === file.id);
              tempArr[idx] = {...data[idx], uploadStatus: {...data[idx].uploadStatus, loaded: 100, status: 'finished'}}
              return tempArr;
            });
            rSucess(file);
          })
          .catch(err => {
            setUploadFiles(data => {
              let tempArr = [...data];
              const idx = findIndex(data, el => el.id === file.id);
              tempArr[idx] = {...data[idx], uploadStatus: {...data[idx].uploadStatus, status: 'failed'}}
              return tempArr;
            });
            rError(file);
          })
        });
      })

    Promise.allSettled(results)
        .then((r) => {
          const failedItems = r.filter(res => res.status === 'rejected');

          if (failedItems.length > 0) {
            startUploadingDrone({uploadingFiles: failedItems});
          }
          else {
            reuploadDone({id:id,
                          originallyUploaded:uploadedImages.length,
                          newImages:uploadFiles.length})
              .then(() => {
                console.log('uploaded');
                setReuploaded(true);
              });
          }

        });

    })
}

  return (
    <>
    {  loading && (
        <LoadingWrapper>
        <h3>Upload Refresh</h3>
        <Loading message="Loading uploaded photos" />
        </LoadingWrapper>
    )}
    {!loading &&(
    <>
    {!reuploaded &&
      <Wrapper>
        <FileUpload onChange={data =>
          filterFiles(data)
        } />
        <Separator />

        {
          uploadFiles.length > 0 && (
          <UploadPreview items={uploadFiles} onRemove={idx => {
            setUploadFiles([
              ...files.slice(0, idx),
              ...files.slice(idx + 1),
            ]);
          }} />
        )}

      </Wrapper>
    }
    {
    (uploadFiles.length > 0) && !reuploaded && (
    <ButtonWrapper>
        <Button onClick={()=>startUploadingDrone(uploadFiles)}>REUPLOAD</Button>
    </ButtonWrapper>)
    }
          {  reuploaded && (
          <ResultWrapper>
            <Result result="positive">
                Project successfully uploaded
            </Result>
          </ResultWrapper>
        )
        }
    </>)}
    </>
  );
}

UploadRefresh.propTypes = {
  id: string.isRequired,
}


export default UploadRefresh

